/**
 * A schema key, made readable: `occurred_at` → "Occurred at" (CT-5183).
 *
 * The catalog names its slots and its display options in `snake_case` and
 * carries no `title` for either — 0 of the 167 `display` properties have one.
 * So the label is an i18n entry where we wrote one and this where we did not,
 * which is what lets a property Data adds tomorrow render with a readable
 * English label instead of not rendering at all.
 *
 * Also used on enum values, which are `SCREAMING_SNAKE`: `PREVIOUS_PERIOD` →
 * "Previous period".
 */
export const humanizeKey = (key) => {
  const words = String(key ?? '').replace(/_/g, ' ').trim().toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

export default humanizeKey;
